export var EField;
(function (EField) {
    EField["Header"] = "_header";
    EField["Content"] = "content";
})(EField || (EField = {}));
